var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",staticStyle:{"cursor":"pointer"},attrs:{"width":"144","height":"44"},on:{"click":_vm.draw}})}
var staticRenderFns = []

export { render, staticRenderFns }